module.exports = __webpack_public_path__ + "img/129.04f47a0e.jpg";